import React, { useCallback } from "react";

import { getCourseDetails, startCourse } from "services";

import { useAppType, useCancelAsyncOnUnmount } from "utils";

import { Button, Col, Row } from "components";

export const CourseHead = ({ course, courseStarted, setActiveChapter, setActiveModule, setCourse, setShowOverlay, slug, t }) => {
  const signal = useCancelAsyncOnUnmount()();
  const appType = useAppType();

  const loadCourseDetails = useCallback(() => {
    getCourseDetails({
      slug,
      signal,
    })
      .then((res) => {
        setCourse(res.course);
      })
      .finally(() => {
        setActiveModule(course.chapters[0].modules[0]);
        setActiveChapter(course.chapters[0]);
        setShowOverlay(true);
      });
  }, [course, setActiveModule, setActiveChapter, setShowOverlay, setCourse, signal, slug]);

  const handleStartCourse = useCallback(() => {
    startCourse({
      slug,
      signal,
    }).then(() => {
      loadCourseDetails();
    });
  }, [loadCourseDetails, signal, slug]);

  return (
    <>
      <section className="container content padded-top">
        <Row>
          <Col>
            <h1>{course.title}</h1>
          </Col>
        </Row>
        {courseStarted ? (
          <Row>
            <Col>
              <p className="paragraph-xl">{course.teaser}</p>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col sm={24} md={14}>
              <p className="paragraph-xl">{course.teaser}</p>
            </Col>
            <Col sm={24} md={2} />
            <Col sm={24} md={8} className="button-container">
              <Button block={!appType.desktop} type="primary" onClick={() => handleStartCourse()}>
                {t("courseOverview.startCourse")}
              </Button>
            </Col>
          </Row>
        )}
      </section>
      <section className="container content padded-top">
        <Row>
          <Col>
            <div
              className="hero-image"
              style={{
                background: `url(${course.images.l})`,
                backgroundSize: "cover",
                backgroundPosition: "center center",
              }}
            />
          </Col>
        </Row>
      </section>
    </>
  );
};
